import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'xs-lib-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.css']
})
export class InputComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
